export default {
    name: 'Name',
    title: 'Stores',
    show: 'Show',
    manage: 'Manage',
    headers: {
        name: 'Name',
        logo: 'Logo',
        createdBy: 'Created By',
        verified: 'Verified',
    },
    verifiedStatus: {
        verified: 'Verified',
        waitingVerification: 'Waiting for admin review',
        notVerified: 'Not verified',
    },
    createStore: 'Create New Store',
    createStoreModal: {
        title: 'Create Store',
        name: 'Name',
        categories: 'Categories',
        categoriesPlaceholder: 'Choose categories',
        pib: 'PIB'
    }
}
